import React from 'react'
import styled from 'styled-components'
import { FreeShippingMembershipV2 } from './FreeShippingMembershipV2'
import useMembershipElementShow from '../../hooks/useMembershipElementShow'
import { useMembershipStorage } from '../../hooks/useMembershipStorage'

const StyledContainer = styled.div`
  border-radius: 4px;
  background: #ffcd05;
  height: 28px;
  width: 100%;
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FreeShippingBadgeV2 = ({ data }) => {
  const showMembership = useMembershipElementShow()
  const { membershipStorage } = useMembershipStorage()
  const hasActiveMembership = membershipStorage?.membership_status === 'ACTIVE'
  const sku = data?.product?.sku

  const isFreeShipping = data?.inventory?.shipping?.type?.toLowerCase() === 'free'

  const isFreeShippingForMembers = data?.inventory?.membershipShippingType === 'Free'

  if (!isFreeShipping && !isFreeShippingForMembers) return null

  if (isFreeShipping) {
    return (
      <StyledContainer
        id={`free-shipping-${sku}`}
        data-testid="freeshipping-badge"
      >
        Free Shipping
      </StyledContainer>
    )
  }

  if ((showMembership || hasActiveMembership) && isFreeShippingForMembers) {
    return <FreeShippingMembershipV2 sku={sku} />
  }

  return null
}
